import { graphql, Environment } from 'react-relay';
import commitMutation from 'relay-commit-mutation-promise';
import {
    AddUserToAutopilotContactsInput,
    addUserToAutopilotContactsMutationResponse,
    addUserToAutopilotContactsMutation,
} from './__generated__/addUserToAutopilotContactsMutation.graphql';

export const mutation = graphql`
    mutation addUserToAutopilotContactsMutation($input: AddUserToAutopilotContactsInput!) {
        addUserToAutopilotContacts(input: $input) {
            clientMutationId
        }
    }
`;

export function addUserToAutopilotContacts(
    environment: Environment,
    input: AddUserToAutopilotContactsInput
): Promise<addUserToAutopilotContactsMutationResponse> {
    return commitMutation<addUserToAutopilotContactsMutation>(environment, {
        mutation,
        variables: { input },
    });
}
